export default __webpack_public_path__ + "static/Natural_Light_Outdoor_2560kbps-5ea51cf561b7c14abe92e2c4dee256d4.avif";